import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, reduxForm} from 'redux-form';
import Titulo from '../../comum/Titulo';
import {buscarPerfis, buscarUsuarios} from '../../../actions/usuario/buscarUsuarios';
import {alterouFiltro, alterouPagina} from '../../../util/filtros';
import {getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa, PERFIL_ADMIN} from '../../../security/securityContext';
import Autorizacao from '../../../security/Autorizacao';
import Usuario from './Usuario'
import ModalCadastrarUsuario from './ModalCadastrarUsuario';
import {alterouEmpresa} from '../../../actions/empresa/alterarEmpresaSelecionada';
import PaginacaoUsuarios from '../PaginacaoUsuarios';
import BotoesPaginacaoUsuarios from '../BotoesPaginacaoUsuarios';
import CabecalhoRodapeTabela from '../../comum/CabecalhoRodapeTabela';
import determinarPaginaAtual from '../../../actions/usuario/determinarPaginaAtualUsuarios';
import alterarRegistrosPorPagina from '../../../actions/usuario/alterarRegistrosPorPaginaUsuarios';
import ModalAlterarUsuario from './ModalAlterarUsuario';
import PainelFiltragem from './PainelFiltrosUsuarios';
import ModalCadastrarUsuarioDescontoRota from './ModalCadastrarUsuarioDescontoRota';
import buscarRotas from '../../../actions/rota/buscarRotas';
import ModalRelacionarAgenciaUsuario from './ModalRelacionarAgenciaUsuario';
import buscarAgencias from '../../../actions/agencia/buscarAgencias';
import bloquearUsuario from '../../../actions/usuario/bloquearUsuario';
import desbloquearUsuario from '../../../actions/usuario/desbloquearUsuario';
import ModalCadastrarMotorista from './ModalCadastrarMotorista';
import CampoSelecionarEmpresa from '../../layout/CampoSelecionarEmpresa';
import { gerarHashForString } from '../../../util/stringUtil';
import ModalHistoricoUsuario from './ModalHistoricoUsuario';
import downloadRelatorioCompletoUsuarios from '../../../actions/usuario/downloadRelatorioCompletoUsuarios';

export const CabecalhoTabela = () => (
    <div className="vx-gp-table-header vx-gp-table-header--usuario d-none d-lg-grid">
        <div>Número</div>
        <div>Nome</div>
        <div>Email</div>
        <div>Empresa</div>
        <div>Telefone</div>
        <div>Ações</div>
    </div>
);

const ModalConfirmacaoBloqueioDesbloqueio = ({usuario, bloquearDesbloquear}) => (
    <div className="modal fade" id="modalConfirmacaoBloqueioDesbloqueio" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacaoBloqueioDesbloqueio" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content vx-modal-content">
                <div className="vx-modal-header">
                    <div className="vx-modal-header-icon">
                        <i className="material-icons">lock</i>
                    </div>
                    <div>
                        <h5 className="vx-modal-title">Bloquear / Desbloquear Usuário</h5>
                    </div>
                    <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close">
                        <i className="material-icons">close</i>
                    </button>
                </div>
                <div className="vx-modal-body">
                    <p><strong>{`Deseja ${usuario.bloqueado ? 'desbloquear' : 'bloquear'} ${usuario.nome}`}</strong></p>
                </div>
                <div className="vx-modal-footer">
                    <button id='cancelar' type="button" className="vx-btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="button" className="vx-btn-primary" data-dismiss="modal"
                            onClick={() => bloquearDesbloquear()}>Confirmar
                    </button>
                </div>
            </div>
        </div>
    </div>);

export class PainelGerenciarUsuario extends React.Component {
    constructor(props) {
        super(props);
        this.limparCampos = this.limparCampos.bind(this);
        this.buscarUsuario = this.buscarUsuario.bind(this);
        this.bloquearDesbloquear = this.bloquearDesbloquear.bind(this);
        this.state = {
            usuarioSelecionado: null,
            textoFiltro: null,
            perfis: [],
            linksSelecionadosModalEdicao: [],

        };
    }

    componentDidMount() {
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.buscarUsuario();
            this.props.buscarAgencias(this.props.empresaSelecionada.id);
            this.props.buscarRotas(this.props.empresaSelecionada.id);
            this.props.buscarPerfis().then(resp => this.setState({perfis: resp.payload.data}));
        }
    }


    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouPagina(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
            if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
                this.props.determinarPaginaAtual(1);
                this.props.alterarRegistrosPorPagina(10);
            }
            this.buscarUsuario()
        }
    }

    buscarUsuario() {
        this.props.buscarUsuarios(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroUsuario',
            'idUsuario', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'nome', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'email', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'perfil', '');
    }

    bloquearDesbloquear() {
        if (this.props.usuarioSelecionado.bloqueado) {
            this.props.desbloquearUsuario(this.props.usuarioSelecionado.id, this.props.empresaSelecionada.id)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.buscarUsuario();
                    }
                })
        } else {
            this.props.bloquearUsuario(this.props.usuarioSelecionado.id, this.props.empresaSelecionada.id)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.buscarUsuario();
                    }
                })
        }
    }

    limparFormulario() {
        this.props.reset('formularioCadastroUsuario');
        this.setState({perfisSelecionados: []})
        this.props.limparPerfis()
        this.buscarUsuario();
    }


    // eslint-disable-next-line class-methods-use-this
    exibirBotaoNovoUsuario() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id)]}>
                <div className="vx-gp-toolbar">
                    <button onClick={() => this.exportarListaUsuarios()} className="vx-btn-secondary">
                        Exportar Lista
                    </button>
                    <button data-toggle="modal" data-target="#modalCadastrarUsuario" className="vx-btn-primary">
                        Cadastrar usuário
                    </button>
                    <button onClick={() => this.props.history.push('/painel-cadastro-usuarios-empresa-lote')} className="vx-btn-secondary">
                        Cadastrar em lote
                    </button>
                </div>
            </Autorizacao>)
    }


    exibirTabelaUsuarios() {
        if (this.props.usuarios && this.props.usuarios.length) {
            return (
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoUsuarios}
                                       BotoesPaginacao={BotoesPaginacaoUsuarios}>
                    <CabecalhoTabela/>
                    {this.exibirUsuarios()}
                </CabecalhoRodapeTabela>
            )
        }
        return (
            <div className="vx-gp-empty">
                <span className="material-icons vx-gp-empty-icon">group</span>
                <p className="vx-gp-empty-text">Nenhum usuário cadastrado para a empresa.</p>
            </div>
        );
    }

    exibirUsuarios() {
        return this.props.usuarios
            .map((usuario, index) => <Usuario key={index} usuario={usuario}
                                              indice={index} 
                                              filtrosAdicionados={this.props.filtrosAdicionados} 
                                              preencherModalEdicao={this.preencherModalEdicao.bind(this)} 
                                              perfis={this.state.perfis}
                                              />)
    }

    preencherModalEdicao(usuarioSelecionado) {
        const links = usuarioSelecionado.links.map(it => { return { hash: gerarHashForString(`${it.tipo}`), id: it.id, tipo: it.tipo, url: it.url } });
        this.setState({ linksSelecionadosModalEdicao: links });
    }

    alterarValoresLinksSelecionados(links) {
        this.setState({ linksSelecionadosModalEdicao: links });
    }

    limparLinks() {
        this.setState({ linksSelecionadosModalEdicao: [] });
    }

    downloadParte(idEmpresa) {
        return this.props.downloadRelatorioCompletoUsuarios(idEmpresa)
            .then(response => response.payload.data);
    }

    executarDownload(arquivo) {
        let a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], { type: 'text/csv;' }));
        a.download = 'Lista de Usuários.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    exportarListaUsuarios() {
        let arquivo = 'Número;Nome;Email;Empresa;Telefone;Ativo/Inativo;Bloqueado/Desbloqueado;Agências;Perfis do usuário;Vender com CTE;Vender com valor ANTT;Vender Gratuidade;Bloquear Edição/Impressão de Passagens;Vender TEF;Habilitar Comissão Passagens Reimpressas de Terceiros;Acréscimo Máximo de Passagem(%);Comissão(%);C.Encomenda(%);C.Excesso Bagagem(%);C.Impressao Bilhete(%);C.Entrega(%);C.Seguro(%);Imposto Retido(%)\n';
        
        this.downloadParte(this.props.empresaSelecionada.id).then(retorno => {
            arquivo = `${arquivo}${retorno.map(it => {
                // Mapear perfis
                const perfis = it.rolesName ? it.rolesName.map(role => role.descricao).join(', ') : '';
                const agencias = it.agencias ? it.agencias.map(role => role.valor).join(', ') : '';
                
                // Mapear comissões
                const comissaoEncomenda = it.comissoes && it.comissoes.length > 0 ? 
                    it.comissoes.find(c => c.tipoServico === 'ENCOMENDA')?.porcentagem || '0.00' : '0.00';
                const comissaoExcessoBagagem = it.comissoes && it.comissoes.length > 0 ? 
                    it.comissoes.find(c => c.tipoServico === 'EXCESSO_BAGAGEM')?.porcentagem || '0.00' : '0.00';
                const comissaoImpressaoBilhete = it.comissoes && it.comissoes.length > 0 ? 
                    it.comissoes.find(c => c.tipoServico === 'IMPRESSAO_BILHETE')?.porcentagem || '0.00' : '0.00';
                const comissaoReserva = it.comissoes && it.comissoes.length > 0 ?
                      it.comissoes.find(c => c.tipoServico === 'RESERVA')?.porcentagem || '0.00' : '0.00';
                const comissaoEntrega = it.comissoes && it.comissoes.length > 0 ?
                      it.comissoes.find(c => c.tipoServico === 'ENTREGA_ENCOMENDA')?.porcentagem || '0.00' : '0.00';
                const comissaoSeguro = it.comissoes && it.comissoes.length > 0 ?
                      it.comissoes.find(c => c.tipoServico === 'SEGURO')?.porcentagem || '0.00' : '0.00';

                let valor = `"${it.id}";"${it.nome}";"${it.email}";"${it.nomeEmpresa || 'N/A'}";"${it.telefone}";"${it.ativo ? 'Ativo' : 'Inativo'}";"${it.bloqueado ? 'Bloqueado' : 'Desbloqueado'}";${ agencias? agencias : ''};"${perfis}";"${it.venderCte ? 'Ativo' : 'Inativo'}";"${it.venderValorANTT ? 'Ativo' : 'Inativo'}";"${it.vendeGratuidade ? 'Ativo' : 'Inativo'}";"${it.bloqueioEdicaoEReimpressaoCupom ? 'Ativo' : 'Inativo'}";"${it.vendaTEF ? 'Ativo' : 'Inativo'}";"${it.habilitadoComissionamentoReimpresaoPassagem ? 'Ativo' : 'Inativo'}";"${it.acrescimoMaximoPassagem || '0.00'}";"${comissaoReserva}";"${comissaoEncomenda}";"${comissaoExcessoBagagem}";"${comissaoImpressaoBilhete}";"${comissaoEntrega}";"${comissaoSeguro}";"${it.impostoRetido || '0.00'}"`
                return valor;
            }).join('\n')}\n`;
            this.executarDownload(arquivo);
        });
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Gerenciar Usuários" urlRetorno="/"/>
                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                            <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                                <div className='row mb-4'>
                                    <div className='col-md-6'>
                                        <CampoSelecionarEmpresa/>
                                    </div>
                                </div>
                            </div>
                        </Autorizacao>
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            <div className="col-12 filtro-busca">
                                <PainelFiltragem/>
                            </div>
                            {this.exibirBotaoNovoUsuario()}
                            {this.exibirTabelaUsuarios()}
                        </div>
                    </div>
                    <ModalCadastrarUsuario buscarUsuario={this.buscarUsuario} perfis={this.state.perfis}/>
                    <ModalCadastrarMotorista/>
                    <ModalAlterarUsuario buscarUsuario={this.buscarUsuario} 
                        perfis={this.state.perfis} 
                        linksSelecionados={this.state.linksSelecionadosModalEdicao} 
                        alterarValoresLinksSelecionados={this.alterarValoresLinksSelecionados.bind(this)}
                        limparLinks={this.limparLinks.bind(this)} />
                    <ModalCadastrarUsuarioDescontoRota/>
                    <ModalRelacionarAgenciaUsuario buscarUsuario={this.buscarUsuario}/>
                    <ModalConfirmacaoBloqueioDesbloqueio
                        bloquearDesbloquear={this.bloquearDesbloquear}
                        usuario={this.props.usuarioSelecionado ? this.props.usuarioSelecionado : ''}/>
                    <ModalHistoricoUsuario/>
                </div>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => {
    return {
        usuarios: state.usuarios.usuarios,
        usuarioSelecionado: state.usuarioSelecionado,
        empresaSelecionada: state.empresaSelecionada,
        perfisSelecionados: state.perfisSelecionados,
        paginaAtual: state.paginaAtualUsuario,
        registrosPorPagina: state.registrosPorPaginaUsuario,
        changeFieldValue,
        filtrosAdicionados: state.filtrosAdicionadosUsuarios,
        total: state.usuarios.total
    }};


export default connect(mapStateToProps, {
    buscarUsuarios,
    buscarPerfis,
    determinarPaginaAtual,
    alterarRegistrosPorPagina,
    buscarRotas,
    buscarAgencias,
    desbloquearUsuario,
    bloquearUsuario,
    downloadRelatorioCompletoUsuarios
})(reduxForm({
    form: 'formularioCadastroUsuario'
})(PainelGerenciarUsuario))
